"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFuturesChartsSteps = exports.useFuturesHistoryRates = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureAPI_1 = require("../../../apis/FutureAPI");
function useFuturesHistoryRates(params) {
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [rates, setRates] = (0, react_1.useState)([]);
    const { symbol, from_time, limit } = params;
    (0, react_1.useEffect)(() => {
        setLoading(true);
        const observer = (0, FutureAPI_1.getFutureHistoryRates)({ symbol }).subscribe({
            next: (data) => {
                setLoading(false);
                // fix null error
                setRates(data.rates || []);
            },
            error: (error) => {
                setLoading(false);
                console.log(error);
            }
        });
        return () => {
            observer.unsubscribe();
        };
    }, [symbol, from_time, limit]);
    return { loading, rates };
}
exports.useFuturesHistoryRates = useFuturesHistoryRates;
function findRatesRange(rates) {
    return rates.reduce((item, { funding_rate }) => {
        if (!item.max) {
            item.max = funding_rate;
            item.min = funding_rate;
            return item;
        }
        const current = new trade_utils_lib_1.SafeDecimal(funding_rate);
        if (current.greaterThan(item.max)) {
            item.max = funding_rate;
            return item;
        }
        if (current.lessThan(item.min)) {
            item.min = funding_rate;
        }
        return item;
    }, { max: "", min: "" });
}
/**y轴上每一格的初始步长，参考币安 */
const INIT_STEP = 0.00005;
/**
 * 计算资金费率的刻度，基准刻度为0.005%
 * @param rates 当前的资金费率列表
 * @returns
 * - step y轴上的刻度，为0.005%的倍数
 * - max y轴上最大刻度
 * - min y轴上最小刻度
 * - labelCount y轴上label个数
 */
function findFuturesChartsSteps(rates) {
    if (!rates || !rates.length) {
        return {
            step: 0,
            max: 0,
            min: 0,
            labelCount: 0,
        };
    }
    // 获取最大值跟最小值
    const { max, min } = findRatesRange(rates);
    const diff = new trade_utils_lib_1.SafeDecimal(max).sub(new trade_utils_lib_1.SafeDecimal(min));
    // 将最大值跟最小值分为三等分，获取每一份包含多少个INIT_STEP，向上取整，获取最终y轴上的步长。
    let step = diff.div(3).div(INIT_STEP).ceil().mul(INIT_STEP);
    // 如果步长小于INIT_STEP，直接设置为INIT_STEP
    if (step.lessThan(INIT_STEP)) {
        step = new trade_utils_lib_1.SafeDecimal(INIT_STEP);
    }
    // 获取y轴刻度的最大跟最小值
    const maxY = new trade_utils_lib_1.SafeDecimal(max).div(step).ceil();
    const minY = new trade_utils_lib_1.SafeDecimal(min).div(step).floor();
    // 针对模拟数据进行特殊处理，真实数据应该不会出现这个情况
    if (maxY.equals(minY)) {
        return {
            step: step.toNumber(),
            max: maxY.add(1).mul(step).toNumber(),
            min: minY.sub(1).mul(step).toNumber(),
            labelCount: diff.div(step).floor().add(2).toNumber(),
        };
    }
    return {
        step: step.toNumber(),
        max: maxY.mul(step).toNumber(),
        min: minY.mul(step).toNumber(),
        labelCount: diff.div(step).floor().add(2).toNumber(),
    };
}
exports.findFuturesChartsSteps = findFuturesChartsSteps;
